import { render, staticRenderFns } from "./search-modal.vue?vue&type=template&id=0a70e8ba&"
import script from "./search-modal.vue?vue&type=script&lang=js&"
export * from "./search-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a70e8ba')) {
      api.createRecord('0a70e8ba', component.options)
    } else {
      api.reload('0a70e8ba', component.options)
    }
    module.hot.accept("./search-modal.vue?vue&type=template&id=0a70e8ba&", function () {
      api.rerender('0a70e8ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/search/search-modal.vue"
export default component.exports